<div class="ticketFilter">
  <div class="ticketFilter-wrapper">
    <h2>
      {{ label }}
    </h2>

    <button aria-label="edit filter" (click)="handleClick()">
      <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
      {{ 'ticket_filter_edit' | i18next }}
    </button>
  </div>
</div>
